<ng-container *ngFor="let alertMessage of alertMessages">
  <app-alert-banner [styleType]="alertMessage.type" [message]="alertMessage.message"></app-alert-banner>
</ng-container>

<app-search-form (searchRequested)="onSearchRequested($event)"></app-search-form>

<div class="d-flex mt-4" *ngIf="showKpis">
    <app-basic-card class="w-100">
        <app-monthly-operations [kpis]="kpis" [countersType]="countersType"></app-monthly-operations>
        <button mat-button color="primary" class="mt-2" (click)="navigate('/kpi')">
            {{'vai ai kpi' | uppercase}}
        </button>
    </app-basic-card>
</div>

<div class="d-flex mt-4">
    <app-basic-card class="w-100">
        <h5>Ultime operazioni</h5>
        <app-basic-table [dataset]="lastOperations" [tableKeys]="tableKeys" (actionRequested)="onDetailRequested($event)">
        </app-basic-table>
        <button mat-button color="primary" class="mt-2" (click)="navigate('/dashboard')">
            {{'vai al cruscotto' | uppercase}}
        </button>
    </app-basic-card>
</div>
